import React from "react";
import classNames from "classnames";

/**
 * Componente de Spinner
 *
 * @param {Object} props - Propiedades del componente
 * @param {String} props.tag - Etiqueta del componente
 * @param {String} props.color - Color del spinner
 * @param {String} props.size - Tamaño del spinner
 * @param {String} props.type - Tipo de spinner
 * @param {String} props.className - Clase del spinner
 * @param {Object} props.children - Componentes hijos
 * @returns {JSX.Element} Componente de React
 */
const Spinner = (props) => {
  const children = props.children || null;
  const Tag = props.tag || "div";
  const color = props.color || "primary";
  const size = props.size || "";

  return (
    <div className="d-flex justify-content-center align-items-center">
      <Tag
        role="status"
        className={classNames(
          {
            "spinner-border": props.type === "bordered",
            "spinner-grow": props.type === "grow",
          },
          [`text-${color}`],
          { [`avatar-${size}`]: size },
          props.className
        )}
      >
        {children}
      </Tag>
    </div>
  );
};

// Propiedades por defecto
Spinner.defaultProps = {
  tag: "div",
  type: "grow",
  size: "md",
};

export default Spinner;
